// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '에이치엘비제약',
  targetSheetName: '제품리스트',
  headerRowIndex: 8,
  headerRowCount: 1,
  dataStartRowIndex: 9,
  columnMapping: {
    drugCode: '제품코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료율',
    commissionNote: '공지1',
  },
  requiredHeaders: [
    'NO',
    '계열',
    '제품명',
    '성분명',
    '대조약',
    '규격',
    '제품코드',
    '약가',
    '수수료율',
    '공지1',
    '공지2',
  ],
});
